export default "__VITE_PUBLIC_ASSET__b3622593__"